<template>
      <div>
           <div style="color: rgb(154, 154, 175);margin: 10px 0 0 0;">您对此次分离操作是否满意？</div>
           <div class="contentStyle"> {{textSet.text1?textSet.text1:'未回答'}}</div>
           <div style="color: rgb(154, 154, 175);margin: 10px 0 0 0;">补充：针对此次分离操作，您觉得哪些方面可以进一步优化？</div>
           <div class="contentStyle"> {{textSet.text2?textSet.text2:'未回答'}}</div>
      </div>
</template>

<script>
    export default {
        name: "GetEvaluation",
        props: {
            textSet: {}
        }
    }
</script>

<style scoped>
    @import "../../../assets/element-component.css";
.contentStyle{
    font-size: 17px;
    font-weight: 600;
    box-sizing: border-box;
    padding: 12px 0 0 0;
}

</style>